// Subscribes to a device's status topic and returns the latest parsed status
// string (the substring between ] and # on `<uno>/client`). Mirrors how the
// Flutter screens listen to mqttMessageStream per device.

import { useEffect, useState } from 'react';
import {
  subscribeTopic,
  unsubscribeTopic,
  addMessageListener,
  parseStatus,
} from './mqttClient';

export function useDeviceStatus(uniqueNumber, initial = '') {
  const [status, setStatus] = useState(initial);

  useEffect(() => {
    if (!uniqueNumber) return undefined;
    const topic = `${uniqueNumber}/client`;
    subscribeTopic(topic);
    const off = addMessageListener((t, payload) => {
      if (t === topic) setStatus(parseStatus(payload));
    });
    return () => {
      off();
      unsubscribeTopic(topic);
    };
  }, [uniqueNumber]);

  return [status, setStatus];
}
